import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ImageText from './ImageText';
import * as styles from '../../../styles/shared/care-image-text-carousel.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const ImageTextCarousel = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!items || items.length === 0) {
    return null;
  }

  // Ajouter une propriété pour indiquer que l'élément est dans un carrousel
  const itemsWithCarouselFlag = items.map(item => ({
    ...item,
    isInCarousel: true
  }));

  return (
    <div className={styles.carouselContainer}>
      <Swiper
        className={styles.carouselWrapper}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        slidesPerView={1}
        spaceBetween={30}
      >
        {itemsWithCarouselFlag.map((item, index) => (
          <SwiperSlide key={`carousel-item-${index}`}>
            <ImageText item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={styles.bullets}>
        {items.map((_, index) => (
          <button
            aria-label={`Aller à la slide ${index + 1}`}
            className={`${styles.bullet} ${index === activeIndex ? styles.active : ''}`}
            key={`bullet-${index}`}
            onClick={() => {
              const swiper = document.querySelector(`.${styles.carouselWrapper}`).swiper;
              swiper.slideTo(index);
            }}
          />
        ))}
      </div>
    </div>
  );
};

ImageTextCarousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      iconUrl: PropTypes.string,
      buttonText: PropTypes.string,
      buttonLink: PropTypes.string,
      buttonTarget: PropTypes.string
    })
  )
};

export default ImageTextCarousel;